// extracted by mini-css-extract-plugin
export default {"container":"MessageFormHeader_container__c+pUf","dropdownContainer":"MessageFormHeader_dropdownContainer__edvAa"};